import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout.vue'
import loading from '@/components/loading.vue'
import contentRouter from './content'

Vue.use(Router)


const routes = [
    contentRouter,
    {
        path: '/',
        name: 'loading',
        component: loading,
    },

    {
        path: '/new',
        name: 'new',
        component: Layout,
        meta: {
            title: "工具箱"
        },
        redirect: '/new/email',
        children: [
            {
                path: 'email',
                name: 'email',
                meta: {
                    title: "批量发送邮件",
                    pagetitle: "批量发送邮件"
                },
                component: () => import('@/views/contentManager/tools/email.vue')
            },
            {
                path: 'addEmail',
                name: 'addEmail',
                meta: {
                    title: "新建批量发送邮件",
                    pagetitle: "新建批量发送邮件"
                },
                component: () => import('@/views/contentManager/tools/addEmail.vue')
            },
            {
                path: 'set-lock-screen',
                name: 'setLockScreen',
                meta: {
                    title: "锁屏工具包更新",
                    pagetitle: "锁屏工具包更新"
                },
                component: () => import('@/views/contentManager/tools/set-lock-screen/view.vue')
            },
            // {
            //     path: 'set-lock-tmp',
            //     name: 'setLockScreen',
            //     meta: {
            //         title: "锁屏工具包更新",
            //         pagetitle: "锁屏工具包更新"
            //     },
            //     component: () => import('@/views/contentManager/tools/set-lock-tmp/view.vue')
            // },
            {
                path: 'new-lock-screen/modify',
                meta: {
                    title: "编辑锁屏工具包",
                    pagetitle: "编辑锁屏工具包"
                },
                component: () => import('@/views/contentManager/tools/new-lock-screen/view.vue')
            },
            {
                path: 'new-lock-screen',
                name: 'newLockScreen',
                meta: {
                    title: "添加模板脚本包",
                    pagetitle: "添加模板脚本包"
                },
                component: () => import('@/views/contentManager/tools/new-lock-screen/view.vue')
            },

            {
                path: 'new-lock-tmp/modify',
                meta: {
                    title: "编辑锁屏工具包",
                    pagetitle: "编辑锁屏工具包"
                },
                component: () => import('@/views/contentManager/tools/new-lock-tmp/view.vue')
            },
            {
                path: 'new-lock-tmp',
                name: 'newLockTmp',
                meta: {
                    title: "添加模板脚本包",
                    pagetitle: "添加模板脚本包"
                },
                component: () => import('@/views/contentManager/tools/new-lock-tmp/view.vue')
            },
            {
                path: 'add-agreement',
                name: 'add-agreement',
                meta: {
                    title: "添加协议类型",
                    pagetitle: "添加协议类型"
                },
                component: () => import('@/views/contentManager/tools/add-agreement/add-agreement.vue')
            },
            {
                path: 'add-people',
                name: 'add-people',
                meta: {
                    title: "添加人员",
                    pagetitle: "添加人员"
                },
                component: () => import('@/views/contentManager/tools/add-people/add-people.vue')
            },
            {
                path: 'add-type',
                name: 'add-type',
                meta: {
                    title: "添加人员",
                    pagetitle: "添加人员"
                },
                component: () => import('@/views/contentManager/tools/add-type/add-type.vue')
            },
            {
                path: 'link-config',
                meta: {
                    title: "友情链接配置",
                },
                component: () => import('@/views/contentManager/tools/link-config/view.vue')
            },
            {
                path: 'temporary-authority',
                meta: {
                    title: "价格审批权限临时分配",
                    btnsAccess: {
                        edit: '200816',
                        delete: '200817'
                    }
                },
                component: () => import('@/views/contentManager/tools/temporary-authority/view.vue')
            },
            {
                path: 'temporary-authority-add-permission',
                meta: {
                    title: "添加权限分配",
                    showHeader: true
                },
                component: () => import('@/views/contentManager/tools/temporary-authority-add-permission/view.vue')
            }
        ]
    },
    {
        path: '/examine',
        name: 'Layout1',
        component: Layout,
        meta: {
        },
        children: [
            {
                path: "entry",
                meta: {
                    showHeader: true,
                    title: "审核台"
                },
                component: () => import('@/views/examine-entry/view.vue'),
            }
        ]
    },
    {
        path: '/business-manage',
        name: 'Layout2',
        component: Layout,
        meta: {
            title: "业务流程管理",
            pagetitle: "业务流程管理",
            showTabs: true
        },
        children: [
            {
                path: "business-process",
                meta: {
                    name: "项目业务",
                    accessId: '201179',
                    btnsAccess: { add: '201180', view: '201181', edit: '201182', del: '201183'}
                },
                component: () => import('@/views/contentManager/tools/process-business/view.vue'),
            },
            {
                path: "business-process-edit/:type",
                meta: {
                    title: ({ params }) => {
                        let prifix = ''
                        switch (params.type) {
                            case 'add':
                                prifix = '添加'
                                break;
                            case 'modify':
                                prifix = '编辑'
                                break;
                            case 'view':
                                prifix = '查看'
                                break;
                        }
                        return `${prifix}业务类型`
                    }
                },
                component: () => import('@/views/contentManager/tools/process-business-edit/view.vue'),
            },
            {
                path: "channel-distribution",
                meta: {
                    name: "渠道分发",
                    accessId: '201184',
                    btnsAccess: { edit: '201185' }
                },
                component: () => import('@/views/contentManager/tools/channel-distribution/channel-distribution.vue'),
            },
            {
                path: "process-works",
                meta: {
                    name: "作品投稿",
                    accessId: '201184',
                    btnsAccess: { edit: '201185' }
                },
                component: () => import('@/views/contentManager/tools/process-works/view.vue'),
            },
            {
                path: "photography-process",
                meta: {
                    name: "摄影投稿",
                    accessId: '201184',
                    btnsAccess: { edit: '201185' }
                },
                component: () => import('@/views/contentManager/tools/process-photography/view.vue'),
            }
        ]
    },
    // 作品发布审核机制
    {
        path: '/workpush',
        name: 'workpush',
        component: Layout,
        meta: {
            title: "作品发布审核机制",
            pagetitle: "作品发布审核机制",
            showTabs: true
        },
        children: [
            {
                path: "indexs",
                meta: {
                    name: "审核方式",
                    accessId: '242',
                    btnsAccess: { add: '245', view: '244', edit: '246', del: '247'}
                },
                component: () => import('@/views/contentManager/tools/workpush/index.vue')
            },
            {
                path: "record",
                meta: {
                    name: "操作记录",
                    accessId: '242',
                    btnsAccess: { add: '245', view: '244', edit: '246', del: '247'}
                },
                component: () => import('@/views/contentManager/tools/workpush/record.vue')
            },
        ]
    },
    //演示demo，apk配置管理
    {
        path: '/apk',
        name: 'apk',
        component: Layout,
        meta: {
            title: "新视界 演示Demo APK",
            pagetitle: "新视界 演示Demo APK",
            showTabs: true
        },
        children: [
            {
                path: "display-object",
                meta: {
                    name: "展示对象",
                    accessId: '242',
                    btnsAccess: { add: '245', view: '244', edit: '246', del: '247'}
                },
                component: () => import('@/views/contentManager/tools/display-object/display-object.vue'),
            },
            {
                path: "resource-management",
                meta: {
                    name: "资源管理",
                    accessId: '243',
                    btnsAccess: { add: '249', view: '248', edit: '250', del: '251',download:'287'}
                },
                component: () => import('@/views/contentManager/tools/resource-management/resource-management.vue'),
            },
        ]
    },
    {
        path: '/luck-draw',
        name: 'Layout3',
        component: Layout,
        meta: {
            title: "抽奖方案",
            pagetitle: "抽奖方案",
            // 是否显示页面header组件
            showHeader: true,
            showTabs: true
        },
        children: [
            {
                path: 'luck-draw-programme',
                meta: {
                    name: "抽奖方案",
                    accessId: '200737',
                    btnsAccess: { view: '200740', add: '200741', modify: '200742', delete: '200743' }
                },
                component: () => import('@/views/contentManager/tools/luck-draw-programme/view.vue')
            },
            {
                path: 'luck-draw-programme-edit/:type',
                meta: {
                    title: ({ params }) => {
                        let prifix = ''
                        switch (params.type) {
                            case 'add':
                                prifix = '添加'
                                break;
                            case 'modify':
                                prifix = '编辑'
                                break;
                            case 'view':
                                prifix = '查看'
                                break;
                        }
                        return `${prifix}抽奖方案`
                    }
                },
                component: () => import('@/views/contentManager/tools/luck-draw-programme-edit/view.vue')
            },
            {
                path: 'prize-edit/:type',
                meta: {
                    title: ({ params }) => {
                        let prifix = ''
                        switch (params.type) {
                            case 'add':
                                prifix = '添加'
                                break;
                            case 'modify':
                                prifix = '编辑'
                                break;
                            case 'view':
                                prifix = '查看'
                                break;
                        }
                        return `${prifix}奖品`
                    },
                },
                component: () => import('@/views/contentManager/tools/prize-edit/view.vue')
            },
            {
                path: 'prize-library',
                meta: {
                    name: "奖品库",
                    accessId: '200738',
                    btnsAccess: { view: '200744', add: '200745', modify: '200746', delete: '200747' }
                },
                component: () => import('@/views/contentManager/tools/prize-library/view.vue')
            },
            {
                path: 'winning-record',
                meta: {
                    name: "中奖纪录",
                    accessId: '200739',
                    btnsAccess: { view: '200748', modifyState: '200749', export: '200750' }
                },
                component: () => import('@/views/contentManager/tools/winning-record/view.vue')
            },
            {
                path: 'winning-record-detail',
                meta: {
                    title: "中奖纪录详情",
                    btnsAccess: { modify: '200749' }
                },
                component: () => import('@/views/contentManager/tools/winning-record-detail/view.vue')
            }
        ]
    },

    {
        path: '/userManager',
        name: 'Layout4',
        component: Layout,
        redirect: '/userManager/userBaseInfo',
        meta: {
            title: "用户"
        },
        children: [{
                path: 'userBaseInfo',
                name: 'userBaseInfo',
                meta: {
                    title: "用户基本信息",
                    pagetitle: "用户基本信息"
                },
                component: () => import('@/views/userManager/userBaseInfo.vue')
            },
            {
                path: 'userInfo',
                name: 'userInfo',
                meta: {
                    title: "供稿人信息表",
                    pagetitle: "用户基本信息"
                },
                component: () => import('@/views/userManager/userInfo.vue')
            },
            {
                path: 'userBaseInfo/userBaseInfoDetail',
                name: 'userBaseInfoDetail',
                meta: {
                    title: "用户基本信息 / 查看用户信息",
                },
                component: () => import('@/views/userManager/userBaseInfoDetail.vue')
            },
            {
                path: 'blackList',
                name: 'blackList',
                meta: {
                    title: "黑名单管理",
                    pagetitle: "黑名单管理"
                },
                component: () => import('@/views/userManager/blackList.vue')
            },
            {
                path: 'blackList/addblack',
                name: 'addblack',
                meta: {
                    title: "黑名单管理 / 添加用户",
                },
                component: () => import('@/views/userManager/addblack.vue')
            },
            {
                path: 'blackList/editblack',
                name: 'editblack',
                meta: {
                    title: "黑名单管理 / 编辑用户",
                },
                component: () => import('@/views/userManager/addblack.vue')
            },
            {
                path: '/userPersonalInfo',
                name: 'userPersonalInfo',
                meta: {
                    title: "供稿人信息表-个人",
                    pagetitle: "供稿人信息表个人"
                },
                component: () => import('@/views/userManager/userPersonalInfo.vue')
            },
            {
                path: 'userPersonalInfo/userPersonalInfoDetail',
                name: 'userPersonalInfoDetail',
                meta: {
                    title: "供稿人信息表-个人 / 查看用户信息"
                },
                component: () => import('@/views/userManager/userPersonalInfoDetail.vue')
            },
            {
                path: 'userCompanyInfo',
                name: 'userCompanyInfo',
                meta: {
                    title: "供稿人信息表-企业-机构",
                    pagetitle: "供稿人信息表企业/机构"
                },
                component: () => import('@/views/userManager/userCompanyInfo.vue')
            },
            {
                path: 'userCompanyInfo/userCompanyInfoDetail',
                name: 'userCompanyInfoDetail',
                meta: {
                    title: "供稿人信息表-企业-机构  /  查看机构信息"
                },
                component: () => import('@/views/userManager/userCompanyInfoDetail.vue')
            },
        ]
    },
    {
        path: '/review',
        component: () => import('@/components/Layoutsht.vue'),
        name: 'Layoutsht',
        redirect:"/review/photography-contribution",
        meta:{
            title:"审核台"
        },
        children: [
            {
                path: 'publishWork',
                name: 'publishWork',
                meta: {
                    title: "作品发布",
                    pagetitle: "作品发布-审核台",
                    accessId: 12
                },
                component: () => import('@/views/review/publishWork.vue')
            },
            {
                path: 'publishWork/workDetial',
                name: 'workDetial',
                meta: {
                    title: "作品发布 / 审核详情"
                },
                component: () => import('@/views/review/workDetial.vue')
            },
            {
                path: 'works-contribution',
                name: 'worksContribution',
                meta: {
                    title: "作品投稿",
                    accessId: 64,
                    btnsAccess: {
                        view: '1001',
                        edit: ['1002', '1003', '1004', '1005'],
                        viewSingle: ['1001', '1002', '1003', '1004', '1005'],
                    }
                },
                component: () => import('@/views/review/works-contribution/view.vue')
            },
            {
                path: 'works-contribution2',
                name: 'worksContribution',
                meta: {
                    title: "渠道分发",
                    accessId: 80,
                    btnsAccess: {
                        view: '81',
                        edit: ['82'],
                        viewSingle: [],
                    }
                },
                component: () => import('@/views/review/works-contribution2/view.vue')
            },
            {
                path: 'photography-contribution',
                name: 'photographyContribution',
                meta: {
                    title: "摄影投稿",
                    accessId: 63,
                    btnsAccess: {
                        view: '200805',
                        edit: ['200806', '200807', '200814'],
                        viewSingle: ['200806', '200807', '200814', '200805'],
                    }
                },
                component: () => import('@/views/review/photography-contribution/view.vue')
            },
            {
                path: 'photography-contribution-detail',
                name: 'photographyContributionDetail',
                meta: {
                    title: "摄影投稿详情",
                    btnsAccess: {
                        edit: ['200806', '200807', '200814']
                    }
                },
                component: () => import('@/views/review/photography-contribution-detail/view.vue')
            },
            {
                path: 'xmBm',
                name: 'xmBm',
                meta: {
                    title: "项目报名",
                    accessId: 61
                },
                component: () => import('@/views/review/xmBm.vue')
            },
            {
                path: 'xmBm1',
                name: 'xmBm1',
                meta: {
                    title: "项目报名"
                },
                component: () => import('@/views/review/xmBm1.vue')
            },
            {
                path: 'xmBm2',
                name: 'xmBm2',
                meta: {
                    title: "项目报名"
                },
                component: () => import('@/views/review/xmBm2.vue')
            },
            {
                path: 'xmBm3',
                name: 'xmBm3',
                meta: {
                    title: "项目报名"
                },
                component: () => import('@/views/review/xmBm3.vue')
            },
            {
                path: 'xmXb',
                name: 'xmXb',
                meta: {
                    title: "项目选标",
                    accessId: 62
                },
                component: () => import('@/views/review/xmXb.vue')
            },
            {
                path: 'xmXb1',
                name: 'xmXb1',
                meta: {
                    title: "项目选标"
                },
                component: () => import('@/views/review/xmXb1.vue')
            },
            {
                path: 'xmXb2',
                name: 'xmXb2',
                meta: {
                    title: "项目选标"
                },
                component: () => import('@/views/review/xmXb2.vue')
            },

            {
                path: 'finalistsWork',
                name: 'finalistsWork',
                meta: {
                    title: "作品入围",
                    pagetitle: "作品入围-审核台",
                    accessId: 13
                },
                component: () => import('@/views/review/finalistsWork.vue')
            },
            {
                path: 'projectreview',
                name: 'projectreview',
                meta: {
                    title: "项目验收",
                    pagetitle: "项目验收-审核台"
                },
                component: () => import('@/views/review/projectreview.vue')
            },
            {
                path: 'projectreview/projectrepending',
                name: 'projectrepending',
                meta: {
                    title: "项目验收 / 我的待审",
                    accessId: 16,
                    btnsAccess: {
                        view: '52'
                    }
                },
                component: () => import('@/views/review/projectrepending/view.vue')
            },
            {
                path: 'projectreview/projectrethrough',
                name: 'projectrethrough',
                meta: {
                    title: "项目验收 / 我通过的",
                },
                component: () => import('@/views/review/projectrethrough.vue')
            },
            {
                path: 'projectreview/projectrerejected',
                name: 'projectrerejected',
                meta: {
                    title: "项目验收 / 我驳回的",
                },
                component: () => import('@/views/review/projectrerejected.vue')
            },
            {
                path: 'projectreview/projectreallrecords',
                name: 'projectreallrecords',
                meta: {
                    title: "项目验收 / 全部记录",
                },
                component: () => import('@/views/review/projectreallrecords.vue')
            },
            {
                path: 'projectreview/projectdetial',
                name: 'projectdetial',
                meta: {
                    title: "项目验收 / 审核详情",
                    btnsAccess: {
                        edit: ['200806', '200807', '200814']
                    }
                },
                component: () => import('@/views/review/projectdetial-wrap/view.vue')
            },

            // {
            //     path: '/audit-details',   //chenwendeng
            //     name: 'audit-details',
            //     meta: {
            //         title: "渠道分发 / 审核详情",
            //         btnsAccess: {
            //             edit: ['200806', '200807', '200814']
            //         }
            //     },
            //     component: () => import('@/views/review/audit-details/audit-details.vue')
            // },

            {
                path: 'audit-details',
                name: 'audit-details',
                meta: {
                    title: "渠道分发 / 审核详情",
                    btnsAccess: {
                        edit: ['200806', '200807', '200814']
                    }
                },
                component: () => import('@/views/review/aprojectdetial-wrap/view.vue')
            },


            


            {
                path: 'projectreview/xxbmxq',
                name: 'xxbmxq',
                meta: {
                    title: "项目报名 / 审核详情"
                },
                component: () => import('@/views/review/projectdetialbm.vue')
            },
            {
                path: 'projectreview/xxxbxq',
                name: 'xxxbxq',
                meta: {
                    title: "项目选标 / 审核详情"
                },
                component: () => import('@/views/review/projectdetialxb.vue')
            },
            {
                path: 'finalistsWork/workDetial',
                name: 'workDetial1',
                meta: {
                    title: "作品入围 / 审核详情"
                },
                component: () => import('@/views/review/workDetial.vue')
            },
            {
                path: 'employWork',
                name: 'employWork',
                meta: {
                    title: "作品录用",
                    pagetitle: "作品录用-审核台",
                    accessId: 14
                },
                component: () => import('@/views/review/employWork.vue')
            },
            {
                path: 'employWork/workDetial',
                name: 'workDetial2',
                meta: {
                    title: "作品录用 / 审核详情"
                },
                component: () => import('@/views/review/workDetial.vue')
            },
            {
                path: 'applyPerson',
                name: 'applyPerson',
                meta: {
                    title: "供稿人申请",
                    pagetitle: "供稿人申请-审核台",
                    accessId: 15
                },
                component: () => import('@/views/review/applyPerson.vue')
            },
            {
                path: 'applyPerson/workDetial',
                name: 'workDetial3',
                meta: {
                    title: "供稿人申请 / 审核详情"
                },
                component: () => import('@/views/review/workDetial.vue')
            },
            {
                path: 'assembly',
                name: 'assembly',
                meta: {
                    title: "壁纸上线审核",
                    accessId: 1100,
                    btnsAccess: {
                        view: '1100',
                        edit: ['1100'],
                        viewSingle: [],
                    }
                },
                component: () => import('@/views/review/assembly/assembly.vue')
            },
            {
                path: 'add_intervene',
                name: 'add_intervene',
                meta: {
                    title: "组件APP相关/壁纸上线审核/ID干预/新增干预",
                    accessId: 1,
                    btnsAccess: {
                        view: '',
                        edit: [''],
                        viewSingle: [],
                    }
                },
                component: () => import('@/views/review/add_intervene/add_intervene.vue')
            },
            // {
            //     path: 'channel',
            //     name: 'channel',
            //     meta: {
            //         title: "我的待审",
            //         accessId:80
            //     },
            //     component: () => import('@/views/review/channel.vue')
            // },
            // {
            //     path: 'channel-passed',
            //     name: 'channel-passed',
            //     meta: {
            //         title: "我通过的",
            //     },
            //     component: () => import('@/views/review/channel-passed.vue')
            // },
            // {
            //     path: 'channel-reject',
            //     name: 'channel-reject',
            //     meta: {
            //         title: "我驳回的",
            //     },
            //     component: () => import('@/views/review/channel-reject.vue')
            // },
            // {
            //     path: 'channel-all-records',
            //     name: 'channel-all-records',
            //     meta: {
            //         title: "全部记录",
            //     },
            //     component: () => import('@/views/review/channel-all-records.vue')
            // }
        ]
    },
    {
        path:"/power",
        component: Layout,
        name: 'Layout5',
        redirect:"/power/roleManager",
        meta: {
            title: "权限"
        },
        children: [
            {
                path: 'roleManager',
                name: 'roleManager',
                meta: {
                    title: "角色管理",
                    pagetitle: "权限-角色管理"
                },
                component: () => import('@/views/power/roleManager.vue'),
            },
            {
                path: 'roleManager/seeRoles',
                name: 'seeRoles',
                meta: {
                    title: "角色管理 / 查看页面"
                },
                component: () => import('@/views/power/seeRoles.vue'),
            },
            {
                path: 'roleManager/editRoles',
                name: 'editRoles',
                meta: {
                    title: "角色管理 / 编辑角色"
                },
                component: () => import('@/views/power/editRoles.vue'),
            },
            {
                path: 'roleManager/createRoles',
                name: 'createRoles',
                meta: {
                    title: "角色管理 / 添加角色"
                },
                component: () => import('@/views/power/createRoles.vue'),
            },
            {
                path: 'accountManager',
                name: 'accountManager',
                meta: {
                    title: "账号管理",
                    pagetitle: "账号管理"
                },
                component: () => import('@/views/power/accountManager.vue')
            },
            {
                path: 'accountManager/seeaccount',
                name: 'seeaccount',
                meta: {
                    title: "账号管理 / 查看页面"
                },
                component: () => import('@/views/power/seeaccount.vue'),
            },
            {
                path: 'accountManager/setRoles',
                name: 'setRoles',
                meta: {
                    title: "账号管理 / 设置角色"
                },
                component: () => import('@/views/power/setRoles.vue'),
            }

        ]
    },
    {
        path:"/workManager",
        component: Layout,
        name: 'Layout6',
        redirect:"/workManager/workInfoAll",
        meta: {
            title: "作品"
        },
        children:[
            {
                path: "workInfoAll",
                name: 'workInfoAll',
                meta: {
                    title: "作品信息表",
                    pagetitle: "作品信息表"
                },
                component: () => import('@/views/workManager/allList.vue'),
            },
            // {
            //     path: "workInfo",
            //     name: 'workInfo',
            //     meta: {
            //         title: "作品信息表",
            //         pagetitle: "作品信息表"
            //     },
            //     component: () => import('@/views/workManager/workInfo.vue'),
            // },
            {
                path: "workInfo",
                name: 'workInfo',
                meta: {
                    title: "渠道分发作品",
                    pagetitle: "渠道分发作品"
                },
                component: () => import('@/views/workManager/workInfo2.vue'),
            },
            {
                path: "workInfo/workInfoDetial",
                name: 'workInfoDetial',
                meta: {
                    title: "作品信息表 / 作品查看"
                },
                component: () => import('@/views/workManager/workInfoDetial.vue'),
            },
            {
                path: "workInfo/worksShelves",
                name: 'worksShelves',
                meta: {
                    title: "作品信息表 / 作品下架"
                },
                component: () => import('@/views/workManager/worksShelves.vue'),
            },
            {
                path: "workInfo/workEmploy",
                name: 'workEmploy',
                meta: {
                    title: "作品信息表 / 作品录用"
                },
                component: () => import('@/views/workManager/workEmploy.vue'),
            },
            {
                path: "materialBank",
                name: 'materialBank',
                meta: {
                    title: "素材库",
                    pagetitle: "素材库"
                },
                component: () => import('@/views/workManager/materialBank.vue'),
            },
            {
                path: "materialBank/materialBankdetail",
                name: 'materialBankdetail',
                meta: {
                    title: "素材库 / 查看素材信息"
                },
                component: () => import('@/views/workManager/materialBankdetail.vue'),
            },

            {
                path: "commentManager",
                name: 'commentManager',
                meta: {
                    title: "评论回复管理",
                    pagetitle: "评论回复管理"
                },
                component: () => import('@/views/workManager/commentManager.vue'),
            },
            {
                path: "labels",
                name: 'labels',
                meta: {
                    title: "作品标签",
                    pagetitle: "作品标签"
                },
                component: () => import('@/views/workManager/labels.vue'),
            },
            {
                path: "labelsd",
                name: 'labelsd',
                meta: {
                    title: "渠道分发作品",
                    pagetitle: "渠道分发作品"
                },
                component: () => import('@/views/workManager/contribution-reserve-works/contribution-reserve-works'),
            },
        ]
    },
    {
        path:"/activityManager",
        component: Layout,
        name: 'Layout7',
        redirect:"/activityManager/activityClass",
        meta: {
            title: "活动"
        },
        children:[
            {
                path: "activityClass",
                name: 'activityClass',
                meta: {
                    title: "主题分类管理",
                    pagetitle: "主题分类管理"
                },
                component: () => import('@/views/activityManager/activityClass.vue'),
            },
            {
                path: "activityClass/addActivity",
                name: 'addActivity',
                meta: {
                    title: "主题分类管理 / 新建主题分类"
                },
                component: () => import('@/views/activityManager/reviseActivity.vue'),
            },
            {
                path: "activityClass/editActivity",
                name: 'editActivity1',
                meta: {
                    title: "主题分类管理 / 编辑主题分类"
                },
                component: () => import('@/views/activityManager/reviseActivity.vue'),
            },
            {
                path: "activityEmploy",
                name: 'activityEmploy',
                meta: {
                    title: "发布活动",
                    pagetitle: "发布活动"
                },
                component: () => import('@/views/activityManager/activityEmploy.vue'),
            },
            {
                path: "activityEmploy/newActivity",
                name: 'newActivity',
                meta: {
                    title: "发布活动 / 新建活动"
                },
                component: () => import('@/views/activityManager/newActivity.vue'),
            },
            {
                path: "activityEmploy/editActivity",
                name: 'editActivity2',
                meta: {
                    title: "发布活动 / 编辑活动"
                },
                component: () => import('@/views/activityManager/newActivity.vue'),
            },
            {
                path: "activityEmploy/signupInfo",
                name: 'signupInfo',
                meta: {
                    title: "发布活动 / 报名信息"
                },
                component: () => import('@/views/activityManager/signupInfo.vue'),
            },
            {
                path: "activityworks",
                name: 'activityworks',
                meta: {
                    title: "活动作品",
                    pagetitle: "活动作品"
                },
                component: () => import('@/views/activityManager/activityworks.vue'),
            },
            {
                path: "look_works",
                name: 'look_works',
                meta: {
                    title: "入围作品",
                    pagetitle: "入围作品"
                },
                component: () => import('@/views/activityManager/look_works.vue'),
            },
        ]
    },
    {
        path:"/employmentManager",
        component: Layout,
        name: 'Layout8',
        redirect:"/employmentManager/employmentorder",
        meta: {
            title: "录用"
        },
        children:[
            {
                path: "employmentorder",
                name: 'employmentorder',
                meta: {
                    title: "录用订单",
                    pagetitle: "录用-录用订单"
                },
                component: () => import('@/views/employmentManager/employmentorder.vue'),
            },
            {
                path: "employmentorder/orderDetial",
                name: 'orderDetial',
                meta: {
                    title: "录用订单 / 查看详情"
                },
                component: () => import('@/views/employmentManager/orderDetial.vue'),
            },
            {
                path: "channel",
                name: 'channel',
                meta: {
                    title: "分享收益表",
                    pagetitle: "分享收益表"
                },
                component: () => import('@/views/employmentManager/channel.vue'),
            },
        ],
    },
    {
        path:"/otherInformation",
        component: Layout,
        name: 'Layout9',
        redirect:"/otherInformation/embodyRecord",
        meta: {
            title: "其他"
        },
        children:[
            {
                path: "/userLog",
                name: '/userLog',
                meta: {
                    title: "用户浏览记录管理",
                    pagetitle: "用户浏览记录列表"
                },
                component: () => import('@/views/newCom/userLog.vue'),
            },
            {
                path: "/adminLog",
                name: '/adminLog',
                meta: {
                    title: "后台管理员日志管理",
                    pagetitle: "后台管理员日志管理列表"
                },
                component: () => import('@/views/newCom/adminLog.vue'),
            },
            {
                path: "/keyList",
                name: '/keyList',
                meta: {
                    title: "关键词管理",
                    pagetitle: "关键词管理列表"
                },
                component: () => import('@/views/newCom/keyList.vue'),
            },

            
            {
                path: "solicitationTemplate",
                name: 'solicitationTemplate',
                meta: {
                    title: "文件管理",
                    pagetitle: "文件管理"
                },
                component: () => import('@/views/activityManager/solicitationTemplate.vue'),
            },
            {
                path: "embodyRecord",
                name: 'embodyRecord',
                meta: {
                    title: "提现记录表",
                    pagetitle: "提现记录表"
                },
                component: () => import('@/views/otherInformation/embodyRecord.vue'),
            },
            {
                path: "embodyRecord/seeembodyRecord",
                name: 'seeembodyRecord',
                meta: {
                    title: "提现记录表 / 提现记录详情"
                },
                component: () => import('@/views/otherInformation/seeembodyRecord.vue'),
            },
            {
                path: "presetReason",
                name: 'presetReason',
                meta: {
                    title: "审核驳回理由预设",
                    pagetitle: "审核驳回理由预设"
                },
                component: () => import('@/views/otherInformation/presetReason.vue'),
            },
            {
                path: "presetReason/revisePresetReason",
                name: 'revisePresetReason',
                meta: {
                    title: "审核驳回理由预设 / 添加驳回理由"
                },
                component: () => import('@/views/otherInformation/revisePresetReason.vue'),
            },
            {
                path: "feedback",
                name: 'feedback',
                meta: {
                    title: "意见反馈",
                    pagetitle: "意见反馈"
                },
                component: () => import('@/views/otherInformation/feedback.vue'),
            },
            {
                path: "feedback/newfeedback",
                name: 'newfeedback',
                meta: {
                    title: "意见反馈 / 新建问题类型预设"
                },
                component: () => import('@/views/otherInformation/newfeedback.vue'),
            },
            {
                path: "feedback/seefeedback",
                name: 'seefeedback',
                meta: {
                    title: "意见反馈 / 反馈内容 / 查看页面"
                },
                component: () => import('@/views/otherInformation/seefeedback.vue'),
            },
            {
                path: "reportInfo",
                name: 'reportInfo',
                meta: {
                    title: "举报信息",
                    pagetitle: "举报信息"
                },
                component: () => import('@/views/otherInformation/reportInfo.vue'),
            },
            {
                path: "reportInfo/seereportInfo",
                name: 'seereportInfo',
                meta: {
                    title: "举报信息 / 举报内容 / 查看页面"
                },
                component: () => import('@/views/otherInformation/seereportInfo.vue'),
            },
            {
                path: "reportInfo/newreportInfo",
                name: 'newreportInfo',
                meta: {
                    title: "举报信息 / 新建举报分类预设"
                },
                component: () => import('@/views/otherInformation/newreportInfo.vue'),
            },
            {
                path: "/contentManager/serviceCenter",
                name: 'serviceCenter',
                meta: {
                    title: "文档服务中心",
                    pagetitle: "文档服务中心"
                },
                component: () => import('@/views/contentManager/serviceCenter.vue'),
            },
            {
                path: "/contentManager/serviceCenter/newserviceCenter",
                name: 'newserviceCenter',
                meta: {
                    title: "文档服务中心 / 新建文档"
                },
                component: () => import('@/views/contentManager/newserviceCenter.vue'),
            },
            {
                path: "/contentManager/serviceCenter/editserviceCenter",
                name: 'editserviceCenter',
                meta: {
                    title: "文档服务中心 / 编辑文档"
                },
                component: () => import('@/views/contentManager/newserviceCenter.vue'),
            },
        ],
    },
    {
        path:"/art",
        component: Layout,
        name: 'Layout10',
        redirect:"/art/item0",
        meta: {
            title: "遇鉴"
        },
        children:[
            {
                path: "/classList",
                name: '/classList',
                meta: {
                    title: "csss",
                    pagetitle: "cssss"
                },
                component: () => import('@/views/contentManager/new/classList.vue'),
            },

            {
                path: "item0",
                name: 'item0',
                meta: {
                    title: "用户信息表",
                    pagetitle: "遇鉴-用户信息表"
                },
                component: () => import('@/views/art/item0/index.vue'),
            },
            {
                path: "item1",
                name: 'item1',
                meta: {
                    title: "发现艺术",
                    pagetitle: "遇鉴-发现艺术"
                    
                },
                component: () => import('@/views/art/item1/index.vue'),
            },
            {
                path: "item1-addContent",
                name: 'item1-addContent',
                meta: {
                    title: "新建展示位",
                },
                component: () => import('@/views/art/item1/addContent.vue'),
            },
            {
                path: "item1-addBanner",
                name: 'item1-addBanner',
                meta: {
                    title: "新建banner",
                },
                component: () => import('@/views/art/item1/addBanner.vue'),
            },
            {
                path: "item2",
                name: 'item2',
                meta: {
                    title: "空中逛展",
                    pagetitle: "遇鉴-空中逛展"
                },
                component: () => import('@/views/art/item2/index.vue'),
            },
            {
                path: "item2-addBanner",
                name: 'item2-addBanner',
                meta: {
                    title: "新建banner",
                },
                component: () => import('@/views/art/item2/addBanner.vue'),
            },
            {
                path: "item3",
                name: 'item3',
                meta: {
                    title: "专题列表",
                    pagetitle: "遇鉴-专题列表"
                },
                component: () => import('@/views/art/item3/index.vue'),
            },
            {
                path: "item3-addList",
                name: 'item3-addList',
                meta: {
                    title: "新建专题列表"
                },
                component: () => import('@/views/art/item3/addList.vue'),
            },
            {
                path: "item3-addContent",
                name: 'item3-addContent',
                meta: {
                    title: "专题列表",
                    pagetitle: "遇鉴-新建内容"
                },
                component: () => import('@/views/art/item3/addContent.vue'),
            },
            // {
            //     path: "item3-table1",
            //     name: 'item3-table1',
            //     meta: {
            //         title: "专题列表"
            //     },
            //     component: () => import('@/views/art/item3/table1.vue'),
            // },
            // {
            //     path: "item3-table2",
            //     name: 'item3-table2',
            //     meta: {
            //         title: "新建内容"
            //     },
            //     component: () => import('@/views/art/item3/table2.vue'),
            // },
            {
                path: "item4",
                name: 'item4',
                meta: {
                    title: "文章管理"
                },
                component: () => import('@/views/art/item4/index.vue'),
            },
            {
                path: "item4-addArticle",
                name: 'item4-addArticle',
                meta: {
                    title: "新建文章"
                },
                component: () => import('@/views/art/item4/addArticle.vue'),
            },
            {
                path: "item5",
                name: 'item5',
                meta: {
                    title: "玩趣古今",
                    pagetitle: "玩趣古今"
                },
                component: () => import('@/views/art/item5/index.vue'),
            },
            {
                path: "item5-addContent",
                name: 'item5-addContent',
                meta: {
                    title: "新建展示位",
                },
                component: () => import('@/views/art/item5/addContent.vue'),
            },
            {
                path: "item5-addBanner",
                name: 'item5-addBanner',
                meta: {
                    title: "新建banner",
                },
                component: () => import('@/views/art/item5/addBanner.vue'),
            },
            {
                path: "item6",
                name: 'item6',
                meta: {
                    title: "趣读",
                    pagetitle: "趣读-展示位"
                    
                },
                component: () => import('@/views/art/item6/index.vue'),
            },
            {
                path: "item6-addContent",
                name: 'item6-addContent',
                meta: {
                    title: "新建展示位",
                },
                component: () => import('@/views/art/item6/addContent.vue'),
            },
            {
                path: "item6-addBanner",
                name: 'item6-addBanner',
                meta: {
                    title: "新建banner",
                },
                component: () => import('@/views/art/item6/addBanner.vue'),
            },


            {
                path: "item-channel",
                name: 'item-channel',
                meta: {
                    title: "渠道管理",
                    pagetitle: "渠道管理"
                },
                component: () => import('@/views/art/channel/list.vue'),
            },
            {
                path: "item-pages",
                name: 'item-pages',
                meta: {
                    title: "渠道页面管理",
                    pagetitle: "渠道页面管理"
                },
                component: () => import('@/views/art/channel/pages.vue'),
            },
            {
                path: "item-pages-cont",
                name: 'item-pages-cont',
                meta: {
                    title: "渠道页面管理",
                    pagetitle: "渠道页面管理"
                },
                component: () => import('@/views/art/item67/index.vue'),
            },
            {
                path: "item-addContent",
                name: 'item-addContent',
                meta: {
                    title: "新建展示位",
                },
                component: () => import('@/views/art/item67/addContent.vue'),
            },
            {
                path: "item-addBanner",
                name: 'item-addBanner',
                meta: {
                    title: "新建Banner",
                },
                component: () => import('@/views/art/item67/addBanner.vue'),
            },
            {
                path: "fastappfeedback-list",
                name: 'fastappfeedback-list',
                meta: {
                    title: "反馈管理",
                },
                component: () => import('@/views/art/fastappfeedback/index.vue'),
            },
            {path: "kyy-tools",
            name: 'kyy-tools',
            meta: {
                title: "快应用工具箱",
            },
            component: () => import('@/views/art/tools/holdAll.vue')},
            {
                path: "novel_review",
                name: 'novel_review',
                meta: {
                    title: "小说内容审核",
                },
                component: () => import('@/views/art/tools/novel_review/novel_review.vue')
            },
            {
                path: "activity_lottery",
                name: 'activity_lottery',
                meta: {
                    title: "活动抽奖信息",
                },
                component: () => import('@/views/art/tools/activity_lottery/activity_lottery.vue')
            },
            {
                path: "winning_details",
                name: 'winning_details',
                meta: {
                    title: "中奖用户信息",
                },
                component: () => import('@/views/art/tools/winning_details/winning_details.vue')
            },
            {
                path: "mood_post",
                name: 'mood_post',
                meta: {
                    title: "心情贴头像列表",
                },
                component: () => import('@/views/art/tools/mood_post/mood_post.vue')
            },
            {
                path: "pao_pao",
                name: 'pao_pao',
                meta: {
                    title: "汽水泡泡内容列表",
                },
                component: () => import('@/views/art/tools/pao_pao/pao_pao.vue')
            },
            {
                path: "lion_pen",
                name: 'lion_pen',
                meta: {
                    title: "狮圈儿内容审核",
                },
                component: () => import('@/views/art/tools/lion_pen/lion_pen.vue')
            },
            {
                path: "astrological_love",
                name: 'astrological_love',
                meta: {
                    title: "星座心愿审核",
                },
                component: () => import('@/views/art/tools/astrological_love/astrological_love.vue')
            },
            {path: "baseAdvList",
            name: 'baseAdvList',
            meta: {
                title: "趣读打底互推广告管理",
            },
            component: () => import('@/views/art/tools/baseAdvList.vue')},
            {path: "baseAdvAdd",
            name: 'baseAdvAdd',
            meta: {
                title: "添加趣读打底",
            },
            component: () => import('@/views/art/tools/addContent.vue')}

        ]
    },

    {
        path:"/noticeManager",
        component: Layout,
        name: 'Layout11',
        redirect:"/noticeManager/newsRelease",
        meta: {
            title: "通知"
        },
        children:[
            {
                path:"newsRelease",
                name: 'newsRelease',
                meta: {
                    title: "发布通知",
                    pagetitle: "通知-发布通知"
                },
                component: () => import('@/views/noticeManager/newsRelease.vue'),
            },
            {
                path:"newsRelease/addrelease",
                name: 'addrelease',
                meta: {
                    title: "发布通知 / 新建通知",
                    pagetitle: "通知-发布通知-新建通知"
                },
                component: () => import('@/views/noticeManager/addrelease.vue'),
            },
            {
                path:"newsRelease/editrelease",
                name: 'editrelease',
                meta: {
                    title: "发布通知 / 编辑通知",
                    pagetitle: "通知-发布通知-编辑通知"
                },
                component: () => import('@/views/noticeManager/addrelease.vue'),
            },
            {
                path:"noticetemplate",
                name: 'noticetemplate',
                meta: {
                    title: "系统通知模板",
                    pagetitle: "通知-系统通知模板"
                },
                component: () => import('@/views/noticeManager/noticetemplate.vue'),
            },
        ]
    },

    {
        path:"/projectManagement",
        component: Layout,
        name: 'Layout12',
        redirect:"/projectManagement/projectclass",
        meta: {
            title: "项目"
        },
        children:[
            {
                path:"projectclass",
                name: 'projectclass',
                meta: {
                    title: "项目分类预设",
                    pagetitle: "项目-项目分类预设"
                },
                component: () => import('@/views/projectManagement/projectclass.vue'),
            },
            {
                path:"projectclass/newprojectclass",
                name: 'newprojectclass',
                meta: {
                    title: "新建项目发布",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/newprojectclass.vue'),
            },
            {
                path:"projectclass/editprojectclass",
                name: 'editprojectclass',
                meta: {
                    title: "编辑项目发布",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/newprojectclass.vue'),
            },
            {
                path:"projectclass/newtemplate",
                name: 'newtemplate',
                meta: {
                    title: "项目分类预设 / 模板预设 / 新建预设模板",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/newtemplate.vue'),
            },
            {
                path:"projectclass/edittemplate",
                name: 'edittemplate',
                meta: {
                    title: "项目分类预设 / 模板预设 / 编辑项目发布",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/newtemplate.vue'),
            },
            {
                path:"projectclass/seetemplate",
                name: 'seetemplate',
                meta: {
                    title: "查看页面",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/seetemplate.vue'),
            },
            {
                path:"projectList",
                name: 'projectList',
                meta: {
                    title: "常规项目",
                    pagetitle: "项目-常规项目"
                },
                component: () => import('@/views/projectManagement/projectList.vue'),
            },
            {
                path:"projectLongList",
                name: 'projectLongList',
                meta: {
                    title: "长期项目",
                    pagetitle: "项目-长期项目"
                },
                component: () => import('@/views/projectManagement/projectLongList.vue'),
            },
            {
                path:"projectZList",
                name: 'projectZList',
                meta: {
                    title: "子项目",
                    pagetitle: "项目-子项目"
                },
                component: () => import('@/views/projectManagement/projectZList.vue'),
            },
            {
                path:"Profit",
                name: 'Profit',
                meta: {
                    title: "收益成长设置",
                    pagetitle: "项目-收益成长设置"
                },
                component: () => import('@/views/projectManagement/Profit.vue'),
            },
            {
                path:"settlement",
                name: 'settlement',
                meta: {
                    title: "分成结算表",
                    pagetitle: "项目发布-分成结算表"
                },
                component: () => import('@/views/projectManagement/settlement.vue'),
            },
            {
                path:"projectList/newproject",
                name: 'newproject',
                meta: {
                    title: "新建项目",
                    pagetitle: "项目-新建项目"
                },
                component: () => import('@/views/projectManagement/newproject.vue'),
            },
            {
                path:"projectList/newprojectLong",
                name: 'newprojectLong',
                meta: {
                    title: "新建长期项目",
                    pagetitle: "项目-新建长期项目"
                },
                component: () => import('@/views/projectManagement/newprojectLong.vue'),
            },
            {
                path:"projectList/projectDetial",
                name: 'projectDetial',
                meta: {
                    title: "查看页面",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/projectDetial.vue'),
            },
            {
                path:"projectList/projectDetialLong",
                name: 'projectDetialLong',
                meta: {
                    title: "查看长期项目页面",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/projectDetialLong.vue'),
            },
            {
                path:"projectList/editproject",
                name: 'editproject',
                meta: {
                    title: "编辑页面",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/newproject.vue'),
            },
            {
                path:"projectList/editprojectlong",
                name: 'editprojectlong',
                meta: {
                    title: "编辑页面",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/newprojectLong.vue'),
            },
            {
                path:"projectList/presentation",
                name: 'presentation1',
                meta: {
                    title: "验收报告",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectManagement/presentation.vue'),
            },
            {
                path:"projectList/newproject/openproject",
                name: 'presentation2',
                meta: {
                    title: "预览项目",
                    pagetitle: "项目发布"
                },
                component: () => import('@/views/projectweb/cents.vue'),
            },
        ]
    },

    {
        path: '/userinfo',
        name: 'Layout13',
        component: Layout,
        meta: {
            title: "首页"
        },
        children:[
            {
                path: 'user',
                name: 'user',
                meta: {
                    title: "账号信息",
                    pagetitle: "账号信息"
                },
                component: () => import('@/components/userinfo.vue')
            }
        ]

    },

    {
        path:"/quan",
        name: 'quan',
        meta: {
            title: "验收报告",
            pagetitle: "项目发布"
        },
        component: () => import('@/views/quan/quan.vue'),
    },

    {
        path: "/contribution-library",
        name: 'contributionLibrary',
        meta: {
            title: "作品投稿库",
            pagetitle: "作品投稿库",
            showHeader: true,
            showTabs: true
        },
        component: Layout,
        children: [
            {
                path: 'ordinary-works',
                meta: {
                    name: "普通作品",
                    accessId: '282',
                    btnsAccess: {
                        bind: '284',
                        download: '286',
                        view: '283',
                        export: '285'
                    }
                },
                component: () => import('@/views/workManager/ordinary-works/view.vue')
            },
            {
                path: 'photographic-works',
                meta: {
                    name: "摄影作品",
                    accessId: '277',
                    btnsAccess: {
                        bind: '279',
                        download: '281',
                        view: '278',
                        export: '280'
                    }
                },
                component: () => import('@/views/workManager/photographic-works/view.vue')
            }
        ]
    },
    {
        path: '/expediting',
        name: 'expediting',
        component: Layout,
        meta: {
            title: "投稿 催审&催稿上线 配置与查询",
            pagetitle: "投稿 催审&催稿上线 配置与查询",
            // 是否显示页面header组件
            showHeader: true,
            showTabs: true
        },
        children: [
            {
                path: 'expediting',
                meta: {
                    name: "可催周期",
                    accessId: '255',
                    btnsAccess: { edit:'256' }
                },
                component: () => import('@/views/contentManager/tools/expediting/expediting')
            },
            {
                path: 'expediting-records',
                meta: {
                    name: "催审记录",
                    accessId: '257',
                    btnsAccess: { view: '258' }
                },
                component: () => import('@/views/contentManager/tools/expediting-records/expediting-records')
            },
            {
                path: 'expediting-online-record',
                meta: {
                    name: "催稿上线记录",
                    accessId: '259',
                    btnsAccess: { view: '260' }
                },
                component: () => import('@/views/contentManager/tools/expediting-online-record/expediting-online-record')
            }
        ]
    },
    //暂时
    {
        path: "/contribution-reserve-works",
        name: 'contribution-reserve-works',
        meta: {
            title: "作品投稿库",
            pagetitle: "作品投稿库",
            showHeader: true,
            showTabs: true
        },
        component: Layout,
        children: [
            {
                path: 'contribution-reserve-works',
                meta: {
                    name: "投稿储备",
                    accessId: '200809',
                    btnsAccess: {
                        bind: '200812',
                        download: '200813',
                        view: '200811',
                        export: '201376'
                    }
                },
                component: () => import('@/views/workManager/contribution-reserve-works/contribution-reserve-works')
            },
            {
                path: 'warehousing-works',
                meta: {
                    name: "入库作品",
                    accessId: '200809',
                    btnsAccess: {
                        bind: '200812',
                        download: '200813',
                        view: '200811',
                        export: '201376'
                    }
                },
                component: () => import('@/views/workManager/warehousing-works/warehousing-works')
            }
        ]
    },
]

var router = new Router({
	routes
})

router.beforeEach((to, from, next) => {
	window.$menuAccess = JSON.parse(localStorage.getItem('access') || '{}')
	next()
})

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export {
    routes
}

export default router

